import { render, staticRenderFns } from "./gameAdPositionConfig.vue?vue&type=template&id=614c45f0&"
import script from "./gameAdPositionConfig.vue?vue&type=script&lang=js&"
export * from "./gameAdPositionConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('614c45f0')) {
      api.createRecord('614c45f0', component.options)
    } else {
      api.reload('614c45f0', component.options)
    }
    module.hot.accept("./gameAdPositionConfig.vue?vue&type=template&id=614c45f0&", function () {
      api.rerender('614c45f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/gameAdPositionConfig.vue"
export default component.exports